import Button from "@amzn/meridian/esm/components/button";
import Icon from "@amzn/meridian/esm/components/icon";
import Theme from "@amzn/meridian/esm/components/theme";
import plusTokens from "@amzn/meridian-tokens/base/icon/plus";
import plusKnockoutTokens from "@amzn/meridian-tokens/base/icon/plus-knockout";
import { addButtonPrimaryTheme, addButtonLinkTheme } from "./insights.constants";

/**
 * AddButton - Shared "Add <thing>" trigger used by Agenda and Action Items.
 *   variant="primary" — solid teal call-to-action (empty state).
 *   variant="link" (default) — subtle grey link (populated-list footer).
 */
// Meridian's plus icon ships at a fixed native size and ignores icon size tokens, so the whole
// icon is scaled down. Local to this file: the link variant's leading "+" is the only user.
const addIconStyle = { transform: "scale(0.9)" };

const AddButton = ({ label, variant = "link", onClick, disabled = false }) => {
  if (variant === "primary") {
    return (
      <Theme tokens={addButtonPrimaryTheme}>
        <Button type="primary" size="small" onClick={onClick} disabled={disabled}>
          <Icon tokens={plusTokens} />
          {label}
        </Button>
      </Theme>
    );
  }

  return (
    <Theme tokens={addButtonLinkTheme}>
      <Button type="link" size="small" onClick={onClick} disabled={disabled}>
        <div style={addIconStyle}>
          <Icon tokens={plusKnockoutTokens} />
        </div>
        {label}
      </Button>
    </Theme>
  );
};

export default AddButton;
